import React, { useCallback, useEffect, useRef } from "react";
import CloseIcon from "../images/close-icon-white.svg";
import Stitch from "../images/stitch-logo.svg";
import Qlik from "../images/qlik-logo.svg";
import Talend from "../images/talend-logo.svg";
import { experiences } from "../data";

const JobModal = ({ job, callback }) => {
    const modalRef = useRef();
    const isOpen = job !== null && job !== undefined;

    const companyLogos = {
      "Stitch": Stitch,
      "Talend": Talend,
      "Stitch/Talend": Talend,
      "Qlik": Qlik,
    }

    const closeModal = useCallback(() => {
	callback(null);
	document.getElementById("html").classList.remove("locked");
    }, [callback]);

    useEffect(() => {
	if (!isOpen) return;

	const handleClickOutside = (event) => {
	    if (modalRef.current && !modalRef.current.contains(event.target)) {
		closeModal();
	    }
	};
	const handleKeyDown = (event) => {
	    if (event.key === "Escape") closeModal();
	};

	document.addEventListener("mousedown", handleClickOutside);
	document.addEventListener("keydown", handleKeyDown);
	return () => {
	    document.removeEventListener("mousedown", handleClickOutside);
	    document.removeEventListener("keydown", handleKeyDown);
	};
    }, [isOpen, closeModal]);

    if (!isOpen) return null;

    const { jobTitle, company, date, description, jobs } = experiences[job];

    return (
	<div className="job-modal-container" role="dialog" aria-modal="true" aria-label={`${jobTitle} at ${company}`}>
	    <div ref={modalRef} className="job-modal">
		<div className="bg-dark-text d-flex justify-content-end position-fixed w-100 py-4 pe-4">
		    <button
			type="button"
			className="d-flex align-items-center pointer job-modal-close"
			onClick={closeModal}
			aria-label="Close details"
		    >
			<div className="me-2">close</div>
			<img className="close-icon" src={CloseIcon} alt="" />
		    </button>
		</div>
		<div className="job-modal-info m-auto">
		    <div className="d-flex justify-content-between">
			<div>
			    <h2>{jobTitle}</h2>
			    <div className="d-flex align-items-end">
				{companyLogos[company] && <img className="job-logo" src={companyLogos[company]} alt={company} />}
				<div className="mt-3 fst-italic text-white-50">
				    <h4 className="fw-bold mb-1">{company}</h4>
				    <h6 className="fst-italic">{date}</h6>
				</div>
			    </div>
			</div>
		    </div>
		    <div className="divider my-4" />
		    {description && <p className="mt-5">{description}</p>}
		    <ul className="mt-4">
			{jobs.map((job, index) => (
			    <li key={index}><p>{job}</p></li>
			))}
		    </ul>
		</div>
		<div className="fade-div" />
	    </div>
	</div>
    );
};

export default JobModal;
